import { useTranslation } from 'react-i18next';
import { estApiError } from '../../api/errors.js';
export function ErreurNewsletter({ erreur }: { erreur: unknown }) {
  const { t } = useTranslation(['regie', 'commun', 'erreurs']);
  if (!erreur) return null;
  const code = estApiError(erreur) ? erreur.code : null;
  const texte =
    code === 'connecteur.non_configure'
      ? t('regie:newsletter.reglages.nonConfigureAide')
      : code?.startsWith('newsletter.')
        ? t(`erreurs:${code}`)
        : t('commun:erreurReseau');
  return <p role="alert">{texte}</p>;
}
